import React from 'react'
import { Image, Modal } from "react-bootstrap";
import {
  ModalTitle,
  PriceCol,
} from './donateNowModalStyle'
import donateNowImage from '../../../assests/images/donatmodal.svg';
import DollarPrice from '../dollarPrice';
import UsdDonate from '../../common/commonUsdDonate/UsdDonate';
import { ModalText } from './latestNewsubmitStyle';
import { MESSAGE } from '../../../utils/message';
interface DonateNowProps {
  metadata: { title: string };
  editDonateNowOpen: boolean;
  setDonateNowOpen: any;
  donationAmount: any;
  formik: any;
}
const DonateNowModal: React.FC<DonateNowProps> = ({ metadata, editDonateNowOpen, setDonateNowOpen, donationAmount, formik }: DonateNowProps) => {

  return (
    <Modal show={editDonateNowOpen} className='claim-nonprofit-modal donateModal'
      onHide={() => setDonateNowOpen(false)} centered>
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body>
        <Image src={donateNowImage} />
        <ModalTitle>{MESSAGE.donatingTo(metadata?.title)}</ModalTitle>
        <ModalText>{MESSAGE.supportOneWarmCoatDescription}</ModalText>
        <PriceCol>
          <DollarPrice donationAmount={donationAmount} formik={formik} />
        </PriceCol>
        <UsdDonate formik={formik} />
      </Modal.Body>
    </Modal>
  )
}

export default DonateNowModal;
